export default {
  name: 'PiggyBankIcon'
};